
window.API_CONFIG = {
  dev: {
    baseUrl: "https://gateway.kent.co.in/dev/crm/",
    key: "yh0eYZneik998yicQAChZ1EYNkw6KJrK7s6LSuDF",
    mapKey: "AIzaSyArm0SRgqqaVEvoKoQdDkSnAZXkckJE2x4",
    otpGatewayUrl: "https://ceuso1mroe.execute-api.ap-south-1.amazonaws.com/dev/crm/gupshup/",
    otpKey: "yh0eYZneik998yicQAChZ1EYNkw6KJrK7s6LSuDF"
  },
  prod: {
    baseUrl: "https://gateway.kent.co.in/prod/crm/",
    key: "n6e1s0JPo17qD17hGupxs5GuhwTgpWsL84Zfh78q",
    mapKey: "AIzaSyArm0SRgqqaVEvoKoQdDkSnAZXkckJE2x4",
    otpGatewayUrl: "https://ceuso1mroe.execute-api.ap-south-1.amazonaws.com/prod/crm/gupshup/",
    otpKey: "n6e1s0JPo17qD17hGupxs5GuhwTgpWsL84Zfh78q"
  }
}

window.API_ENV = window.location.hostname.includes("staging") ? "dev" : "prod";

window.getAPIUrl = function (key) {
  return window.API_CONFIG[window.API_ENV][key]
}


// async function getAuthToken() {
//   try {
//     const url = window.getAPIUrl("authUrl");
//     const body = new URLSearchParams({
//       grant_type: "client_credentials",
//       client_id: "3MVG93GE3_KkEn6.j_TaNhjUpxEvpwrja7aEUJqfAkTPEfMKXLXqf._Hq40jxg6BquJKI7pq4U5rinKPVZIN0",
//       client_secret: "1A44D822C2B3F3B7248ECA2CC303DC21E60BE10B982450F3FFBF22FC29581846"
//     });

//     const res = await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded"
//       },
//       body
//     });

//     const data = await res.json();

//     if (data.access_token) {
//       localStorage.setItem("api_token", data.access_token);
//     }
//   } 
//   catch (err) {
//     console.error("Auth error:", err);
//   }
// }

// async function getDealerLocAuthToken() {
//   try {
//     const url = window.getAPIUrl("authDealerLoc");

//     const res = await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded"
//       }
//     });

//     const data = await res.json();

//     if (data.token) {
//       localStorage.setItem("dealerLoc_token", data.token);
//     }
//   } 
//   catch (err) {
//     console.error("Auth error:", err);
//   }
// }


// window.addEventListener("load", getDealerLocAuthToken);